import Sidebar from "../Side/Sidebar";
import Loader from '../Animations/Loader';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { useState, useEffect } from "react";
import Topbar from "../Side/Topbar";
import PaymentApiService from '../../ApiServices/PaymentApiServices/PaymentApiService';
import InvoiceApiService from '../../ApiServices/InvoiceApiService/InvoiceApiService';
import AddPaymentModelForm from "../Payment/AddPaymentModelForm";
import { useAuth } from "../Auth/AuthContext"; // Import useAuth
import AdminSidebar from "../Side/AdminSidebar";
import { useNavigate } from "react-router-dom";

const Payment = () => {
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false); // State to control modal open/close
  const { authState } = useAuth(); // Get authState from AuthContext
  const [lastPaidInvoice, setLastPaidInvoice] = useState(null);
  const [lastUnPaidInvoice, setLastUnPaidInvoice] = useState(null);
  const role = authState.roles;
  const admin = role === "Admin";
  const user = authState.user;

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, });

    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      if (admin) {
        const paymentData = await PaymentApiService.Get();
        setData(paymentData.data[0] || {});
      } else {
        const paymentData = await PaymentApiService.GetByUser(user.id);
        setData(paymentData.data || {});
        const lastPaidInvoiceData = await InvoiceApiService.GetLastPaidInvoice(user.id);
        const lastUnPaidInvoiceData = await InvoiceApiService.GetLastUnPaidInvoice(user.id);
        setLastPaidInvoice(lastPaidInvoiceData.data);
        setLastUnPaidInvoice(lastUnPaidInvoiceData.data);
      }
      // const paymentData = await PaymentApiService.Get();

      // setData(paymentData.data[0] || {});
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const navigate = useNavigate();

  const handleShowTransaction = () => {
    navigate("/transactions");
  };

  return (
    <div className="flex">
      {/* Sidebar */}
      {admin ? <AdminSidebar /> : <Sidebar />}

      {/* Main Content */}
      <div className="flex-1 bg-gray-100">

        <div className="flex-1 flex flex-col">
          <Topbar></Topbar>
          <div className="mt-20 p-6 bg-gray-100 min-h-screen flex-grow">
            <div className="max-w-7xl mx-auto">
              {/* Payment Summary */}
              <div className="bg-white shadow-lg rounded-lg p-6 mb-8">
                <div className="flex justify-between items-center">
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900">Last paid invoice date
                      {" " + lastPaidInvoice?.previousMonth + " " + lastPaidInvoice?.year}</h2>
                    <p className="text-sm text-gray-500">
                      Expected new payment date: {
                        new Intl.DateTimeFormat('en-US', { month: 'long' }).format(
                          new Date(new Date().getFullYear(), new Date().getMonth() + 1)
                        )
                      }
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-3xl font-bold text-gray-900">${lastPaidInvoice?.revenue  - lastPaidInvoice?.deductions}.00</p> 
                    <p className="text-sm text-gray-500">Est. Revenue: ${lastPaidInvoice?.revenue}.00</p>
                    <p className="text-sm text-gray-500">Deductions: ${lastPaidInvoice?.deductions}.00</p>
                  </div>
                </div>
                <div className="mt-4">
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: "100%" }}></div>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">You've reached 100% of your payment threshold.</p>
                  <p className="text-sm font-medium mt-2">Payment threshold: $200</p>
                </div>
              </div>
              <div className="mt-6">
                {/* Button to Open Modal */}
                <button
                  onClick={() => setOpenModal(true)} // Open the modal
                  className="mb-4 px-4 py-2 bg-blue-500 text-white rounded-md"
                >
                  Add Payment Details
                </button>
                <AddPaymentModelForm isOpen={openModal} closeModal={() => setOpenModal(false)}
                  fetchData={fetchData} // Pass fetchData function
                />

              </div>
              {/* Transactions and Payment Method */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Transactions */}
                <div className="bg-white shadow-lg rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Transactions</h3>
                  <table className="w-full">
                    <thead>
                      <tr className="text-left text-sm font-semibold text-gray-500">
                        <th>Expected payment date</th>
                        <th>Expected pending invoices estimated amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-gray-700">
                        <td className="py-2">{
                        new Intl.DateTimeFormat('en-US', { month: 'long' }).format(
                          new Date(new Date().getFullYear(), new Date().getMonth() + 1)
                        )
                      }</td>
                        <td className="py-2"> ${lastUnPaidInvoice?.revenue}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="mt-4">
                    <button
                      className="text-blue-600 hover:underline transition-all duration-300 hover:text-blue-800"
                      onClick={handleShowTransaction}
                    >
                      VIEW TRANSACTIONS
                    </button>
                  </div>
                </div>

                {/* Payment Method */}
                <div className="bg-white shadow-lg rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Payment Method</h3>
                  <p className="text-gray-700">
                    <strong>Bank Transfer</strong>
                  </p>
                  <p className="text-sm text-gray-500">
                    Bank Account Number: <span className="font-medium">{data.bankAccountNumber}</span>
                  </p>
                  <p className="text-sm text-gray-500">Bank name: {data.bankName}</p>
                  <p className="text-sm text-gray-500">
                    Bank branch: {data.bankBranch}
                  </p>
                  <p className="text-sm text-gray-500">Owner: {data.owner}</p>
                  <p className="text-sm text-gray-500">Swift code: {data.swiftCode}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;
